export default "__VITE_ASSET__CAGHe9ZI__"